import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import '../components/home/home.css';
import '../styles/design-tokens.css';
import PageLayout from '../components/home/PageLayout';


/* ─────────────────────────────────────────────
   Testimonials data  (all entries from reference/feedback.html)
───────────────────────────────────────────── */
const TESTIMONIALS = [
  {
    img: '/images/testimonials/Hital Shah.jpg',
    name: 'Hital Shah',
    desig: 'MIT BE CIVIL 1993-94',
    short:
      '"I was his class student from the year 1991 to 1993 to learn structural engineering. I am his student for life to learn the principles of life. One extraordinary knack that sir has while he teaches on the board, is the excellent way he can use the full board and his straight upright writing that clears all the concepts with smoothness is unbeatable.',
    full:
      ' I rarely have seen any teacher who can use the board so efficiently. The methodical way in which we have learnt the subjects from him are a true reflection of his personality which is very straight forward and quite a logical approach to everything in life. I really wish him all the best for his new endeavor in digital study platform and hope to see many students benefitting from the crisp and crystal clear way of his teaching. May God keep sir Healthy always. Jai shree krishna."',
  },
  {
    img: '/images/testimonials/Suhas Mohol.jpg',
    name: 'Suhas Mohol',
    desig: '',
    short:
      '"It was real insight and thoughtfulness on each lecture you had conducted during our classes 20 years back. Structural engineering became more interesting because of your teaching and that is the reason I personally chose structural domain in my career. I have hardly seen a dedicated and committed teacher like you. Your fluid',
    full:
      ' presentation on board was a treat to our eyes and these values are inculcated in our lives. Your books and notes are still used as a manual. I have had a great opportunity to further associate with you after finishing my graduation for a couple of years. That was again a great experience for me. Once again thanks for being our teacher and showing us the path."',
  },
  {
  img: null,
  name: 'Dhairyasheel Mohite',
  desig: '',
  short: "Congratulations for 30 yrs sir. World’s best Sir and guardian for me. Without your support I couldn't reach till here.",
  full: '',
},
  {
    img: '/images/testimonials/Amit Dhulekar.jpg',
    name: 'Amit Nandkishor Dhulekar',
    desig: 'Real Estate Developer',
    short:
      "I still remember that we used to reach the Class of SOM and various other subjects till my final year of BE early morning at 7am from Nigdi. We never dared to be late, not because you were strict but we could not imagine missing a minute of your teaching. You're Insistence of using a Hard",
    full:
      " Cover Book to take down notes and usage of Scale and Pencil to draw diagrams was worth as I could carry and refer those notes even while doing my MS. Many a times I have introduced you to my other friends as my 'University' and I truly mean it. From bottom of my Heart I would like to thank you for making us 'Better Engineers'.",
  },
  {
    img: '/images/testimonials/Prafull Aher.jpg',
    name: 'Prafull Kisan Aher',
    desig: '2004',
    short:
      '"To describe Sir in simple words is that he is like "Krishna" and we students as "Arjuna" in Bhagavad Gita. As a student we face many doubts during the course of our education and Sir has been my mentor like Krishna always guiding me throughout it. In the span of life until now came across my Gurus and mentors enabling me to learn lot of things.',
    full:
      ' In those Gurus I personally have a great place for "Somayya Sir" due to his dedication and perfectionist in what he teaches. Change is evitable and I am happy all your teachings will be online and students not only from Pune but all over India can take benefit from it. I would like to express my deep gratitude for your generous support and teachings that has been a part of me for what I am today."',
  },
  {
    img: '/images/testimonials/Shweta Lokhande.jpg',
    name: 'Shweta Lokhande',
    desig: '',
    short:
      "H.M. Somayya - the popular class for the most dreaded subject of 'Applied Mechanics' for all engineering students! The weekly tests conducted helped me develop the practice of solving sums regularly,",
    full:
      " Somayya Engineering Academy is truly a savior for all civil engineering students. The entire journey of structural engineering becomes a pleasure if taught by Somayya sir. It helped me clear all structural engineering subjects with reasonable grades, helped me crack GATE as well as MPSC Civil exam. I definitely recommend this academy to every student. I wish this academy and Somayya sir all the very best for this new journey of digital education!",
  },
  {
    img: '/images/testimonials/Suhrud Kulkarni.JPG',
    name: 'Suhrud Kulkarni',
    desig: '2012',
    short:
      '"Somayya Sir is an epitome of knowledge, discipline and positivity. His dedication to teaching and imparting education is unparalleled. I was a student of Somayya Sir throughout my Bachelor\'s in Civil Engineering. In addition to tutoring me in Mechanics and Structural design related courses, Sir provided clarity and guidance in deciding the concentration for my Master\'s. Sir\'s passion to provide a better quality of education to everyone makes him stand out and the Academy an incubator for development of young minds.',
    full: '',
  },
  {
    img: '/images/testimonials/Saket Thombre.jpg',
    name: 'Saket Thombre',
    desig: '',
    short:
      '"When I decided to join tuition for engineering mechanics, I thought about Somayya Academy for its excellent track record of mentoring students for their overall development. At Somayya Academy, I found a caring, nurturing, and engaging environment to develop myself. I acquired valuable life skills along with training for my engineering subjects. Guidance',
    full:
      ' from H.M.Somayya Sir has led me through the toughest of situations. The staff at the academy is passionate about students and provides them with enough challenges to enhance their performance. I am truly thankful to Somayya Academy to give me the knowledge and confidence to achieve my goals."',
  },
  {
    img: null,
    name: 'Nainish Munot',
    desig: '',
    short:
      '"Somayya Academy has done a splendid job by inculcating the ability in me to learn and build the strong engineering knowledge provided during my course of 4 years at the Academy. From a student not so fond of Structural courses to a candidate mastered and pursued his career as a Structural Engineer,',
    full:
      " Somayya Sir has done an incredible job not just by teaching the curriculum but by his words of appreciation and constant support to me. His study materials were not only useful to me while pursuing my undergrad in India but also during my MS in USA. I can clearly say that he transformed me from a timid teenager to a confident professional, my Guru H.M.Somayya!\"",
  },
  {
    img: '/images/testimonials/Vicky Punjabi.jpg',
    name: 'Vicky Punjabi',
    desig: 'Year of Passing - 2016 (B.E., Civil) & 2020 (MTech, Structures)',
    short:
      '"Somayya Academy has been the most enthralling journey of my life. H M Somayya sir is a blend of experience and wisdom with energy and enthusiasm. He is been highly supportive throughout my journey of four years. The training at the academy fulfills all the requirements which helped',
    full:
      ' me and many of us to groom and evolve as a professional structural engineer. The only mantra to sustain in academy is to be punctual in attaining all lectures and atleast revise the work done in previous lectures. I owe my gratitude to respected H M Somayya sir."',
  },
  {
    img: '/images/testimonials/Purva Vaidya.jpg',
    name: 'Purva Vaidya',
    desig: '2016',
    short:
      "I'm a student of Somayya sir from 2016 and will be his student forever. Somayya sir's way of teaching is so unique that it is impossible to forget the concepts once taught. I'm glad to have experienced his lectures, dedication and passion towards teaching the engineering subjects. Sir has been an inspiration to me in various aspects of life and will always be my mentor. His love and support towards his students is immeasurable.",
    full: '',
  },
  {
    img: '/images/testimonials/Prasenjeet Anil Baisane Photo.jpg',
    name: 'Prasenjeet Baisane',
    desig: '',
    short:
      "I am Prasenjeet Anil Baisane, currently pursuing my B-Tech in Civil Engineering from MIT-WPU, Pune. I joined Somayya Engineering Academy back in the year 2018 for the subject, Strength of Materials (SOM) and since then I have been under Somayya Sir's guidance for all the other structural subjects.",
    full:
      " Somayya Sir is an excellent teacher who has a very effective and structured method of teaching. He explains each and every concept in a very concise manner. Apart from structures, Somayya Sir has also taught me to be disciplined and helped me be a better version of myself. Thank You so much Somayya Sir for being a fabulous teacher.",
  },
  {
    img: '/images/testimonials/Rutuja Patil.png',
    name: 'Rutuja Patil',
    desig: '2021',
    short:
      'I joined the academy for learning Strength of Materials (SOM) and since then I have been under the guidance of Somayya Sir. He really has a very unique way of teaching and the knowledge he shares is a definite eye-opener.',
    full:
      ' His dedication, work, and approach inspired me to learn each concept in depth. I am grateful to have him as my mentor and will keep pursuing my interest in structures ahead.',
  },
  {
    img: null,
    name: 'Shaunak Vaidya',
    desig: '',
    short:
      'It gives me immense pleasure to express my deep respect, admiration and gratitude towards you. I feel privileged to have had the opportunity to learn innumerable things from you, ever since the time you taught me engineering mechanics at your esteemed academy. You always emphasized the importance of solid understanding of fundamentals.',
    full:
      ' Your teaching method involved precise conceptual explanations and corresponding illustrations through relevant examples. Your exemplary commitment towards your students was evident from the effort you took to ensure that questions from students were answered in detail. Your teachings have been and continue to be an integral part of my journey as an engineer.',
  },
  {
    img: null,
    name: 'Akshay Patil',
    desig: '2017',
    short:
      'I feel special to have worked with the Somayya Academy whose establishment lies in conveying quality education to students as well as adding values in them helping transform their lives. It is a recognized and well-organized institution with an intention to make every student consistent and persistent in learning.',
    full: '',
  },
  {
    img: '/images/testimonials/Purva More.jpg',
    name: 'Purva More',
    desig: '2018',
    short:
      "I joined Somayya Academy for 'Strength of Materials'. Somayya sir's teaching method is very effective. He provided enough practice problems and exposure for students to attempt on different topics with varying degree of difficulty. He goes the extra mile to stay back after the class just to make sure students fully understand and correct their errors.",
    full:
      " He makes his classes engaging, showing SOM concepts by making analogy with daily life examples, meanwhile teaching us answering techniques to help us with challenging examination questions. His classes are the most effective as my grades constantly improved and helped me rank first in SOM Subject during my undergrad. Thank you, Sir!!",
  },
  {
    img: '/images/testimonials/Ramvilas Kendre.jpg',
    name: 'Ramvilas Shivajirao Kendre',
    desig: '2016',
    short:
      "I remember my first day at Somayya Academy, I joined for Mechanics tuition for first year of engineering. Somayya sir always focused on clearing our basic concepts and never thought of taking any short cuts. His teachings were useful for us not only for clearing university examinations",
    full:
      ' but also helping us to deal with day to day life hurdles. Somayya Academy feels like a sacred temple and Sir is like a priest who is always there for blessing and guiding us.',
  },
];

const FALLBACK_IMG = '/images/Somayya-Academy-Best-Coaching-Classes-in-Pune.png';

/* ─────────────────────────────────────────────
   Scroll-reveal hook — mirrors Angular WOW.js behaviour.
   Fires once when the element enters the viewport.
───────────────────────────────────────────── */
function useScrollReveal({ threshold = 0.15 } = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, visible];
}

/* ─────────────────────────────────────────────
   Single testimonial card
───────────────────────────────────────────── */
function TestiCard({ t }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="sa-fb-testi-card">
      <div className="sa-fb-testi-img-wrap">
        <img
          src={t.img || FALLBACK_IMG}
          alt={t.name}
          className="sa-fb-testi-img"
          onError={e => { e.target.src = FALLBACK_IMG; }}
        />
      </div>

      <div className="sa-fb-testi-content">
        <h3 className="sa-fb-testi-name"><a>{t.name}</a></h3>
        {t.desig && <span className="sa-fb-testi-desig">{t.desig}</span>}

        <ul className="sa-fb-testi-stars" aria-label="5 star rating">
          {[1, 2, 3, 4, 5].map(n => (
            <li key={n}><i className="fa fa-star" aria-hidden="true" /></li>
          ))}
        </ul>

        <div className="sa-fb-testi-text">
          {t.short}
          {!expanded && t.full && (
            <button
              className="sa-fb-read-more"
              onClick={() => setExpanded(true)}
              aria-label="Read more"
            >
              …Read more
            </button>
          )}
          {expanded && t.full && (
            <>
              {t.full}
              <br />
              <button
                className="sa-fb-read-more"
                onClick={() => setExpanded(false)}
                aria-label="Show less"
              >
                {' '}Less
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   Interactive star-rating picker for the form
───────────────────────────────────────────── */
function StarRating({ value, onChange }) {
  const [hovered, setHovered] = useState(0);

  return (
    <div className="sa-fb-star-picker" role="radiogroup" aria-label="Select star rating">
      {[1, 2, 3, 4, 5].map(n => (
        <button
          key={n}
          type="button"
          className={`sa-fb-star-btn${n <= (hovered || value) ? ' sa-fb-star-active' : ''}`}
          onClick={() => onChange(n)}
          onMouseEnter={() => setHovered(n)}
          onMouseLeave={() => setHovered(0)}
          aria-label={`${n} star${n > 1 ? 's' : ''}`}
        >
          ★
        </button>
      ))}
      {value > 0 && <span className="sa-fb-star-label">{value} / 5</span>}
    </div>
  );
}

/* ─────────────────────────────────────────────
   Submit feedback form
───────────────────────────────────────────── */
function FeedbackForm() {
  const [formRef, formVisible] = useScrollReveal({ threshold: 0.1 });

  const [rating, setRating]   = useState(0);
  const [fields, setFields]   = useState({ name: '', email: '', role: '', message: '' });
  const [file, setFile]       = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors]   = useState({});

  const validate = () => {
    const e = {};
    if (!fields.name.trim())    e.name    = 'Name is required.';
    if (!fields.role.trim())    e.role    = 'Role is required.';
    if (!fields.message.trim()) e.message = 'Message is required.';
    if (rating === 0)           e.rating  = 'Please select a rating.';
    return e;
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFields(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="sa-fb-form-success" role="alert">
        <i className="fa fa-check-circle" aria-hidden="true" />
        <span>Thank you! Your feedback has been submitted successfully.</span>
      </div>
    );
  }

  return (
    <div
      ref={formRef}
      className={`sa-fb-form-wrap sa-fb-reveal sa-fb-anim-fadeInUp${formVisible ? ' sa-fb-reveal-in' : ''}`}
    >
      {/* Star picker */}
      <div className="sa-fb-form-group">
        <StarRating
          value={rating}
          onChange={v => {
            setRating(v);
            if (errors.rating) setErrors(p => ({ ...p, rating: '' }));
          }}
        />
        {errors.rating && <span className="sa-fb-field-error">{errors.rating}</span>}
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="sa-fb-form-row">

          {/* Name */}
          <div className="sa-fb-form-group sa-fb-half">
            <input
              type="text"
              name="name"
              placeholder="Name *"
              className={`sa-fb-input${errors.name ? ' sa-fb-input-error' : ''}`}
              value={fields.name}
              onChange={handleChange}
              required
              aria-required="true"
            />
            {errors.name && <span className="sa-fb-field-error">{errors.name}</span>}
          </div>

          {/* Email */}
          <div className="sa-fb-form-group sa-fb-half">
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="sa-fb-input"
              value={fields.email}
              onChange={handleChange}
            />
          </div>

          {/* Role */}
          <div className="sa-fb-form-group sa-fb-half">
            <input
              type="text"
              name="role"
              placeholder="Role *"
              className={`sa-fb-input${errors.role ? ' sa-fb-input-error' : ''}`}
              value={fields.role}
              onChange={handleChange}
              required
              aria-required="true"
            />
            {errors.role && <span className="sa-fb-field-error">{errors.role}</span>}
          </div>

          {/* File upload */}
          <div className="sa-fb-form-group sa-fb-half">
            <input
              type="file"
              name="file"
              className="sa-fb-input sa-fb-input-file"
              accept="image/*,.pdf,.doc,.docx"
              onChange={e => setFile(e.target.files[0] || null)}
              aria-label="Upload a file (optional)"
            />
            {file && <span className="sa-fb-file-name">{file.name}</span>}
          </div>

          {/* Message */}
          <div className="sa-fb-form-group sa-fb-full">
            <textarea
              name="message"
              placeholder="Message *"
              className={`sa-fb-input sa-fb-textarea${errors.message ? ' sa-fb-input-error' : ''}`}
              rows={8}
              value={fields.message}
              onChange={handleChange}
              required
              aria-required="true"
            />
            {errors.message && <span className="sa-fb-field-error">{errors.message}</span>}
          </div>

        </div>

        <button type="submit" className="sa-btn sa-btn-primary sa-fb-submit-btn">
          Submit
        </button>
      </form>
    </div>
  );
}

/* ─────────────────────────────────────────────
   Page
───────────────────────────────────────────── */
export default function FeedbackPage() {
  const [sectionRef,  sectionVisible]  = useScrollReveal({ threshold: 0.08 });
  const [formHeadRef, formHeadVisible] = useScrollReveal({ threshold: 0.1 });

  return (
    <PageLayout
      title="STUDENT'S FEEDBACK"
      breadcrumb="Student's Experience at Somayya Academy"
    >
      {/* ══════════════════════════════════════════
          SECTION 1 — What Our Students Say
      ══════════════════════════════════════════ */}
      <div className="sa-fb-students-say-area">

        {/* Heading with fadeInUp on scroll */}
        <div
          ref={sectionRef}
          className={`sa-fb-reveal sa-fb-anim-fadeInUp${sectionVisible ? ' sa-fb-reveal-in' : ''}`}
        >
          <h2 className="sa-fb-section-title">What Our Students Say</h2>
        </div>

        {/* Carousel fades in after heading */}
        <div className="sa-container">
          <div className={`sa-fb-reveal sa-fb-anim-fadeIn${sectionVisible ? ' sa-fb-reveal-in' : ''}`}>
           <Swiper
  modules={[Pagination]}
  pagination={{ clickable: true }}
  loop
  speed={2000}                    // data-smart-speed="2000"
  spaceBetween={30}               // data-margin="30"
  breakpoints={{
    0:   { slidesPerView: 1 },    // data-r-x-small="1"
    480: { slidesPerView: 2 },    // data-r-x-medium="2"
  }}
  className="sa-fb-swiper"
>
              {TESTIMONIALS.map((t, i) => (
                <SwiperSlide key={i}>
                  <TestiCard t={t} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════
          SECTION 2 — Submit Your Ratings
      ══════════════════════════════════════════ */}
      <div className="sa-fb-submit-area">
        <div className="sa-container">

          {/* Heading slides in from left on scroll */}
          <div
            ref={formHeadRef}
            className={`sa-fb-reveal sa-fb-anim-fadeInLeft${formHeadVisible ? ' sa-fb-reveal-in' : ''}`}
          >
            <h2 className="sa-fb-submit-title">SUBMIT YOUR RATINGS</h2>
            <div className="sa-fb-submit-title-bar" aria-hidden="true" />
          </div>

          <FeedbackForm />
        </div>
      </div>
    </PageLayout>
  );
}
